// extracted by mini-css-extract-plugin
export var cardHeader = "_rj-0";
export var reorderHandle = "_rj-3";
export var titleArea = "_rj-1";
export var titleAreaWithHandle = "_rj-2";